import { DataBean } from "../DataBean";

export class AdquisitionContract extends DataBean {

    public async importDataContract(type: number, data: any, idAdquisitionPlan): Promise<any> {
        return this.getCustomService("SupplierERP", "java.util.List_importDataContract_Number_String_Number", [type, data, idAdquisitionPlan]);
    }

    public async getAdquisitionContractRender(page: number | null, rows: number | null, props: any, fechaIni: any, fechaFin: any): Promise<any> {
        return this.getCustomService("FinanceCore", "java.util.List_getAdquisitionContractRender_Number_Number_java.util.Map_java.util.Date_java.util.Date",
            [page, rows, props, fechaIni, fechaFin]);
    }

    public async getAdquisitionContract(idadquisitioncontract: number): Promise<any> {
        return this.getCustomService("FinanceCore", "com.orange.bean.AdquisitionContract_getAdquisitionContract_Number", [idadquisitioncontract]);
    }

    public async getAdquisitionContractRenderReport(page: number, rows: number, props: any, date1: any, date2: any, year: number): Promise<any> {
        return this.getCustomService(
            "FinanceCore",
            "com.advantage.shared.Report_getAdquisitionContractRenderReport_Number_Number_java.util.Map_java.util.Date_java.util.Date_Number",
            [page, rows, props, date1, date2, year]
        );
    }

    public async registerAdquisitionContractByItems(idEmployee: number, contract: any): Promise<any> {
        return this.getCustomService("FinanceCore", "com.orange.bean.AdquisitionContract_registerAdquisitionContractByItems_Number_com.orange.bean.AdquisitionContract", [
            idEmployee,
            {
                "DataBeanProperties": contract,
                "DataBeanName": "com.orange.bean.AdquisitionContract"
            }
        ]);
    }

    public async getAdquisitionContractRenderByIDAccount(page: number, rows: number, props: any, idAccount: number): Promise<any> {
        return this.getCustomService(
            "FinanceCore",
            "java.util.List_getAdquisitionContractRenderByIDAccount_Number_Number_java.util.Map_Number",
            [page, rows, props, idAccount]
        );
    }
    public async getResumenPayment(year: number,props:any,listContract:any): Promise<any> {
        return this.getCustomService(
            "FinanceCore",
            "java.util.List_getResumenPayment_Number_java.util.Map_java.util.List",
            [year,props,listContract]
        );
    }
    public async getPaymentAssignmentCatalogPorPropiedades(map:any,rows:any): Promise<any> {
        return this.getCustomService(
            "FinanceCore",
            "java.util.List_getPaymentAssignmentCatalogPorPropiedades_java.util.Map_Number",
            [map,rows]
        );
    }
    public async updatePaymentAssignment(bean:any): Promise<any> {
        return this.getCustomService(
            "FinanceCore",
            "com.orange.bean.PaymentAssignment_updatePaymentAssignment_com.orange.bean.PaymentAssignment",
            [
                {
                    DataBeanProperties:bean,
                    DataBeanName:"com.orange.bean.PaymentAssignment"
                }
            ]
        );
    }

}   